import { usePipedriveStore } from "..";
import { showErrorToast, showSuccessToast } from "../components/ToastContainer";
import IPipedriveOrganization from "../interfaces/IPipedriveOrganization";

const useOrganizationUpdate = (): (organization: IPipedriveOrganization) => Promise<void> => {
    const pipedriveStore = usePipedriveStore();

    return async (organization: IPipedriveOrganization): Promise<void> => {
        try {
            await pipedriveStore.updateOrganization(organization);
            showSuccessToast();
        } catch (e) {
            showErrorToast();
            throw e;
        }
    };
};

export default useOrganizationUpdate;